import React from 'react';

const UserPanelTitle = () => (
  <div className="user-panel-title">
    <i className="dx-icon-info" />
    <i className="dx-icon-close" />
  </div>
);

export default UserPanelTitle;
